<template>
  <div>
    <div
      id="setting-container">
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="10">
              Assignee
            </b-col>
            <b-col cols="2">
              <j-toggle
                :disabled="visibility.allMember"
                v-model="visibility.assignee"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              Creator
            </b-col>
            <b-col cols="2">
              <j-toggle
                :disabled="visibility.allMember"
                v-model="visibility.creator"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              All Member
            </b-col>
            <b-col cols="2">
              <j-toggle
                v-model="visibility.allMember"/>
            </b-col>
          </b-row>
          <b-button
            class="btn blue pull-right"
            @click="visibilityConfig">
            Apply
          </b-button>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jBoardVisibilityTab',
  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchQuery: '',
      onUpdate: false,
      visibility: {
        assignee: false,
        creator: false,
        allMember: false,
      },

    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board', 'boards_updated', 'form_detail']),
  },
  watch: {
    // eslint-disable-next-line
    'visibility.allMember': function(val) {
      if (val) {
        this.visibility.assignee = false;
        this.visibility.creator = false;
      }
    },

  },
  created() {
    switch (this.board.visibility) {
      case 'creator|assignee':
        this.visibility.assignee = true;
        this.visibility.creator = true;
        break;
      case 'creator':
        this.visibility.creator = true;
        break;
      case 'assignee':
        this.visibility.assignee = true;
        break;
      default:
        this.visibility.allMember = true;
        break;
    }
    // });
  },

  methods: {
    ...mapActions('jStoreBoard', ['actionGetBoards', 'updateForm', 'detailForm', 'updateComponent', 'actionUpdateVisibilityPrivilege', 'actionUpdateEmailReminder']),

    visibilityConfig() {
      if (!this.visibility.creator && !this.visibility.assignee && !this.visibility.allMember) {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Visibility options is required');
      } else {
        const params = {
          visibility: {
            creator: this.visibility.creator,
            assignee: this.visibility.assignee,
            all_member: this.visibility.allMember,
          },
        };
        this.actionUpdateVisibilityPrivilege({ boardId: this.board.id, params });
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/board/tabs/jBoardVisibilityTab.vue